export default function getResource(label) {
    const resources = {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        saveContinue: 'Save & Continue',
        change: 'Change',
        pickupInfoIncompleteError: 'Please complete pickup information.',
        pickupInfoUnsavedError: 'Please confirm pickup information.'
    };

    return resources[label];
}
